/* 1. enable analytics */
(function (g, b, d, f) {
  (function (a, c, d) {
    if (a) {
      var e = b.createElement("style");
      e.id = c;
      e.innerHTML = d;
      a.appendChild(e);
    }
  })(b.getElementsByTagName("head")[0], "at-body-style", d);
  setTimeout(function () {
    var a = b.getElementsByTagName("head")[0];
    if (a) {
      var c = b.getElementById("at-body-style");
      c && a.removeChild(c);
    }
  }, f);
})(window, document, "body {opacity: 0 !important}", 3e3);

/* 2. script */
function isMobile() {
  var check = false;
  (function (a) {
    if (
      /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(
        a
      ) ||
      /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
        a.substr(0, 4)
      )
    ) {
      check = true;
    }
  })(navigator.userAgent || navigator.vendor || window.opera);
  return check;
}
var channelVal;
if (isMobile()) {
  channelVal = "Mobile Site";
} else {
  channelVal = "Brand Site";
}
digitalData = {
  siteInfo: {
    channel: "",
    sitetype: "Shopify",
  },
  page: {
    pageInfo: {
      destinationURL: window.location.href,
    },
    category: {
      pageType: "Checkout",
    },
  },
  video: [],
  campaign: [],
  product: [],
  privacy: {
    accessCategories: [
      {
        domains: [],
      },
    ],
  },
  component: [],
  trackingInfo: {
    GID: "",
    un: "",
    tool: [
      {
        ids: "",
      },
    ],
  },
  promotion: [],
};
digitalData.siteInfo.channel = channelVal;
digitalData.page.category.primaryCategory = channelVal;
digitalData.trackingInfo = {};
digitalData.trackingInfo.tool = [{}];
digitalData.trackingInfo.tool[0] = {};
digitalData.trackingInfo.tool[1] = {};
digitalData.privacy = {}; //Optional
digitalData.page.attributes = {};
digitalData.privacy.accessCategories = [{}]; //Optional
digitalData.privacy.accessCategories[0].domains = []; //Optional
digitalData.event = [];
digitalData.page.pageInfo.pageName = "Checkout"; //To be set on each page change
digitalData.page.pageInfo.language = "en";
digitalData.page.category.subCategory1 = "";
digitalData.page.category.subCategory2 = "";
digitalData.page.category.subCategory3 = "";
digitalData.page.attributes.contentType = "other"; // To be set on each page change. Should contain 404 for error pages
digitalData.page.attributes.articleName = "";
digitalData.page.attributes.brandCategory = "foods";
digitalData.page.attributes.country = "US";
digitalData.page.attributes.globalBrand = "talentigelato";
digitalData.page.attributes.localBrand = "talentigelato";
//digitalData.user[n].profile[n].profileInfo.crmID = 'CRM ID'; //Optional
digitalData.trackingInfo.tool[0].id = "G-BMNC6B8HZK";
digitalData.trackingInfo.tool[1].id = "unileverna-talentigelato-us";
digitalData.siteInfo.internalDomain = "shop.talentigelato.com";

/* 3. Adobe launch script */
const adobeSource = document.createElement("script");
adobeSource.setAttribute("id", "launch");
adobeSource.setAttribute(
  "src",
  "https://assets.adobedtm.com/e6bd1902389a/633dd490ad68/launch-ec8b08881b01.min.js"
);
document.head.appendChild(adobeSource);

/*purchase event*/
function eventPurchase(cData) {
  console.log("cData", cData);

  digitalData.transaction = {};
  digitalData.transaction = {
    transactionID: cData.order.id,
    total: {
      basePrice: cData.totalPrice.amount,
      taxRate: cData.totalTax.amount,
      shipping: cData.shippingLine.price.amount,
    },
    "coupon Discount": "",
    shipMethod: "",
    shipCountry: cData.shippingAddress.country,
    shipCity: cData.shippingAddress.city,
    attributes: {
      affiliation: "affiliation",
      coupon: "coupon",
    },
  };

  digitalData.transaction.item = [];
  const orderItems = cData.lineItems;
  for (var i = 0; i < orderItems.length; i++) {
    digitalData.transaction.item.push({
      productInfo: {
        productID: orderItems[i]?.variant?.product?.id,
        productName: orderItems[i]?.variant?.product?.title,
        price: parseFloat(orderItems[i]?.variant?.price?.amount),
        brand: orderItems[i]?.variant?.product?.vendor,
        quantity: orderItems[i].quantity,
        discount: "",
        tax: "",
        shipping: "",
      },
    });
  }

  var ev = {};
  ev.eventInfo = {
    type: ctConstants.purchaseenhanced,
  };
  ev.category = { primaryCategory: ctConstants.custom };
  digitalData.event.push(ev);
}

/* 5. Google tag (gtag.js) */
const googleTagSource = document.createElement("script");
googleTagSource.setAttribute("id", "googleTagManager");
googleTagSource.setAttribute(
  "src",
  "https://www.googletagmanager.com/gtag/js?id=G-XX0LLP73TH"
);
// googleTagSource.setAttribute('async', '');
document.head.appendChild(googleTagSource);

window.dataLayer = window.dataLayer || [];
function gtag() {
  dataLayer.push(arguments);
}
gtag("js", new Date());
gtag("config", "G-XX0LLP73TH");
gtag('config', 'AW-865546459');
gtag('config', 'AW-1005697677');